import "./Atoms.css";
import { Tooltip } from "react-tooltip";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { sampleDownload } from "../Function/Helper";

export const ExportButton = ({ label, datas, onClick }) => {
  return (<>
    <Button
      label={label}
      icon="pi pi-upload"
      className="custom-btn p-button-help"
      disabled={datas?.length === 0}
      onClick={onClick}
      aria-label="Export file"
      data-tooltip-id={"Export"}
      data-tooltip-content={"Export"}
      data-tooltip-offset={10}
    />
    <Tooltip id={"Export"} className="tooltip" />
  </>);
};

export const SampleButton = ({ label, fileUrl, fileName, type }) => {
  return (<>
    <Button
      label={label}
      icon="pi pi-file"
      className="custom-btn p-button-help"
      onClick={() => sampleDownload(fileUrl, fileName, type)}
      aria-label="Sample file"
      data-tooltip-id={"Sample"}
      data-tooltip-content={"Sample"}
      data-tooltip-offset={10}
    />
    <Tooltip id={"Sample"} className="tooltip" />
  </>);
};

export const NewButton = ({ onClick }) => {
  return (<>
    <Button
      label="New"
      icon="pi pi-plus"
      className="new-btn"
      onClick={onClick}
      aria-label="Add New Data"
      data-tooltip-id={"New"}
      data-tooltip-content={"New"}
      data-tooltip-offset={10}
    />
    <Tooltip id={"New"} className="tooltip" />
  </>);
};

export const DeleteButton = ({ onClick, disabled }) => {
  return (<>
    <Button
      label="Delete"
      icon="pi pi-trash"
      className="delete-btn"
      onClick={onClick}
      disabled={disabled}
      aria-label="Delete Datas"
      data-tooltip-id={"Delete"}
      data-tooltip-content={"Delete"}
      data-tooltip-offset={10}
    />
    <Tooltip id={"Delete"} className="tooltip" />
  </>);
};

export const ActionButton = ({ icon, onClick, id, toolText }) => {
  return (
    <>
      <Button
        icon={`pi ${icon}`}
        outlined
        className="me-2 rounded-circle action-btn"
        onClick={onClick}
        aria-label={toolText}
        data-tooltip-id={id}
        data-tooltip-content={toolText}
        data-tooltip-offset={10}
      />
      <Tooltip id={id} className="tooltip" />
    </>
  );
};

export const SearchBar = ({ position, onInput }) => {
  return (
    <IconField iconPosition={position}>
      <InputIcon className="pi pi-search" />
      <InputText
        type="search"
        onInput={onInput}
        placeholder="Search..."
        aria-label={"Search Item here"}
      />
    </IconField>
  );
};

export const NormalButton = ({
  label,
  icon,
  disabled = false,
  outlined = false,
  onClick,
}) => {
  return (<>
    <Button
      label={label}
      icon={`pi ${icon}`}
      disabled={disabled}
      outlined={outlined}
      onClick={onClick}
      className={`mx-1 ${outlined ? "close-btn" : "ok-btn"}`}
      aria-label={label}
      data-tooltip-id={label}
      data-tooltip-content={label}
      data-tooltip-offset={10}
    />
    <Tooltip id={label} className="tooltip" />
  </>);
};
